import { Button } from "@light-technology/components";
import { Mail01 } from "@untitledui/icons";
import { PARTNER_SUCCESS_EMAIL } from "../../utilities/constants";

type NoPlanStateProps = {
  hasPlans?: boolean;
  days?: number;
};

export function NoPlanState({ hasPlans = false, days }: NoPlanStateProps) {
  if (hasPlans) {
    const daysText = days ? `${days.toString()} days` : "this period";
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-xl px-3xl pt-3xl pb-3xl text-center">
        <div className="flex max-w-md flex-col gap-md">
          <h4 className="text-lg font-semibold">No enrollments found</h4>
          <p className="text-sm text-tertiary">
            No enrollments for the past {daysText}.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-[28px] flex flex-1 flex-col items-center justify-center gap-xl px-3xl pt-3xl pb-3xl text-center">
      <div className="flex max-w-md flex-col gap-md">
        <h4 className="text-lg font-semibold">No enrollments found</h4>
        <p className="text-sm text-tertiary">
          You'll be able to track customer enrollment here when you have recent
          enrollments. Reach out to us for questions.
        </p>
      </div>
      <Button
        color="secondary"
        size="md"
        iconLeading={Mail01}
        href={`mailto:${PARTNER_SUCCESS_EMAIL}`}
        target="_blank"
      >
        Email us
      </Button>
    </div>
  );
}
